/**
 * useJobDocuments Hook
 *
 * React Query hook for fetching a job's documents.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import type { JobDocumentsParams } from '../api/jobDocumentsApi';
import { getJobDocuments } from '../api/jobDocumentsApi';

export function useJobDocuments(jobId: number, params: JobDocumentsParams = {}) {
  const query = useQuery({
    queryKey: queryKeys.jobs.documents(String(jobId)),
    queryFn: () => getJobDocuments(jobId, params),
    enabled: jobId > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
